import { History, DollarSign, CheckCircle } from 'lucide-react';

function formatDateRange(start, end) {
  if (!start || !end) return 'Unknown period';
  const startDate = new Date(start);
  const endDate = new Date(end);
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  return `${startDate.toLocaleDateString('en-US', options)} - ${endDate.toLocaleDateString('en-US', options)}`;
}

export function RoyaltyHistoryList({ royaltyHistory }) {
  return (
    <div className="glass-card p-6">
      <h3 className="font-semibold mb-4 flex items-center gap-2">
        <History className="w-5 h-5 text-yellow-400" />
        Distribution History
      </h3>

      {royaltyHistory.length === 0 ? (
        <div className="text-center py-8 bg-white/5 rounded-lg">
          <DollarSign className="w-12 h-12 text-gray-600 mx-auto mb-3" />
          <p className="text-gray-400">No royalties distributed yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {royaltyHistory.map((royalty) => (
            <div 
              key={royalty.id || `${royalty.period_start}-${royalty.period_end}`}
              className="flex items-center justify-between p-4 bg-white/5 rounded-lg"
              data-testid={`royalty-${royalty.id}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-green-500/20 flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-green-400" />
                </div>
                <div>
                  <p className="font-medium">
                    {formatDateRange(royalty.period_start, royalty.period_end)}
                  </p>
                  <p className="text-sm text-gray-400">
                    {royalty.distributions?.length || 0} holders received payment
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-xl font-bold text-green-400">
                  ${royalty.total_amount?.toFixed(2)}
                </p>
                <p className="text-xs text-gray-500">total distributed</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
